import { render, staticRenderFns } from "./DatasetManager.vue?vue&type=template&id=4b9c9dd0&scoped=true"
import script from "./DatasetManager.vue?vue&type=script&lang=js"
export * from "./DatasetManager.vue?vue&type=script&lang=js"
import style0 from "./DatasetManager.vue?vue&type=style&index=0&id=4b9c9dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9c9dd0",
  null
  
)

export default component.exports